<ol class="flex items-start">
  @for (phase of phases(); track phase.phase; let i = $index) {
    <li class="relative flex flex-1 flex-col items-center">
      <!-- Connectors, centred on the medal -->
      @if (i > 0) {
        <span
          class="absolute left-0 h-0.5 w-1/2 -translate-y-1/2 transition-colors duration-500"
          [style.top.px]="medalSize() / 2"
          [class.bg-primary-400]="isPreviousPhaseComplete(i)"
          [class.bg-greyscale-200]="!isPreviousPhaseComplete(i)"
        ></span>
      }
      @if (i < phases().length - 1) {
        <span
          class="absolute left-1/2 h-0.5 w-1/2 -translate-y-1/2 transition-colors duration-500"
          [style.top.px]="medalSize() / 2"
          [class.bg-primary-400]="phase.isComplete"
          [class.bg-greyscale-200]="!phase.isComplete"
        ></span>
      }

      <button
        type="button"
        (click)="onSelect(phase.phase)"
        [disabled]="compact()"
        [attr.aria-current]="phase.isCurrent ? 'step' : null"
        [pTooltip]="
          'help.onboarding.journey.phases.' + phase.phase + '.title' | transloco
        "
        tooltipPosition="top"
        class="relative z-10 flex items-center justify-center rounded-full border-2 bg-white font-semibold transition-all duration-300"
        [class.cursor-pointer]="!compact()"
        [class.hover:scale-105]="!compact()"
        [class.border-primary-500]="phase.isComplete || phase.isCurrent"
        [class.bg-primary-500]="phase.isComplete"
        [class.text-white]="phase.isComplete"
        [class.text-primary-600]="phase.isCurrent && !phase.isComplete"
        [class.ring-4]="phase.isCurrent && !phase.isComplete"
        [class.ring-primary-100]="phase.isCurrent && !phase.isComplete"
        [class.border-greyscale-300]="!phase.isComplete && !phase.isCurrent"
        [class.text-greyscale-500]="!phase.isComplete && !phase.isCurrent"
        [style.width.px]="medalSize()"
        [style.height.px]="medalSize()"
        [style.font-size.px]="compact() ? 12 : 14"
      >
        @if (phase.isComplete) {
          <lucide-icon
            [name]="phaseIcons[phase.phase]"
            [size]="compact() ? 15 : 18"
          />
        } @else {
          {{ phase.position }}
        }
      </button>

      @if (!compact()) {
        <span
          class="mt-2 max-w-[90%] text-center text-paragraph-xs-med"
          [class.text-greyscale-900]="phase.isCurrent || phase.isComplete"
          [class.text-greyscale-500]="!phase.isCurrent && !phase.isComplete"
        >
          {{
            "help.onboarding.journey.phases." + phase.phase + ".short"
              | transloco
          }}
        </span>
        <span
          class="text-center text-paragraph-xs-reg"
          [class.text-primary-600]="phase.isComplete"
          [class.text-greyscale-500]="!phase.isComplete"
        >
          {{ phase.completed }}/{{ phase.total }}
        </span>
      }
    </li>
  }
</ol>
